/**
 * Default Intl locale when i18n has no language, or when resolving an empty
 * locale list. Also used as the mapping target for bare `'en'`.
 * Change this (and only this) to switch English date order, e.g. to `'en-US'`.
 *
 * Lives in its own module so jest-setup can import it without loading
 * react-i18next / i18next (which would break per-file mocks of those packages).
 */
export const DEFAULT_FORMATTING_LOCALE = 'en-GB';
